/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
import React, {useEffect, useState} from 'react';
import theme from '../../../global/styles/theme';
import TextDefault from '../../../components/TextDefault';
import {StatusBarContainer} from '../../../components/StatusBar';
import * as S from './styles';
import {RootState} from '../../../store';
import {useDispatch, useSelector} from 'react-redux';
import {ActivityIndicator, Dimensions, FlatList, ScrollView, Text} from 'react-native';
import Button from '../../../components/Button';
import {toPrice} from '../../../utils/functions';
import {Logo} from '../../../../assets';
import Input from '../../../components/Input';
import {useForm} from 'react-hook-form';
import {schemaSearch} from '../../../utils/schema';
import {yupResolver} from '@hookform/resolvers/yup';
import {View} from 'react-native';
import {getAuctions} from '../../../services/auctions';
import {useIsFocused} from '@react-navigation/native';
import {refreshToken} from '../../../services/auth';
import {updateUser} from '../../../store/modules/user/actions';
import {getBanners} from '../../../services/banner';

const searchResolver = {
  resolver: yupResolver(schemaSearch),
};

export default function HomeScreen() {
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const {
    control,
    formState: {errors},
  } = useForm(searchResolver);
  const dispatch = useDispatch();

  const focus = useIsFocused();

  const [listGavel, setListGavel] = useState<Array<any>>([]);
  const [listBanners, setListBanners] = useState<Array<any>>([]);
  const [page, setPage] = useState(1);
  const [qtdPages, setQtdPages] = useState(1);
  const [finishUpdateToken, setFinishUpdateToken] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState<
    'maiores_altas' | 'venda_direta' | 'maior_lance' | ''
  >('');

  const getListGavel = async () => {
    try {
      setIsLoading(true);
      const response = await getAuctions(
        type === 'venda_direta' ? 'direta' : 'all',
        type === 'maior_lance' ? 'highest_bids' : undefined,
        undefined,
        undefined,
        page,
        userInfo?.token,
      );
      setIsLoading(false);
      setQtdPages(response?.result?.qtdPages || 1);
      setListGavel(response?.result?.list || []);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  };

  const getListBanner = async () => {
    try {
      const response = await getBanners(1, userInfo?.token);
      setListBanners((response?.result?.list || [])?.map((e: any) => e.file));
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  };

  const getNewToken = async () => {
    await refreshToken(
      {refresh: userInfo?.tokenRefresh, type: 'users'},
      userInfo?.token,
    )
      .then(response => {
        const newToken = response?.data?.result?.token;
        dispatch(
          // @ts-ignore
          updateUser({
            ...userInfo,
            token: newToken || userInfo?.token,
            user: response?.data?.result?.user,
          }),
        );
        setFinishUpdateToken(true);
      })
      .catch(error => {
        console.log('error', error);
        setFinishUpdateToken(true);
      });
  };

  useEffect(() => {
    if (focus && userInfo?.tokenRefresh) {
      setTimeout(() => {
        getNewToken();
      }, 300);
    }
  }, [focus]);

  useEffect(() => {
    if (focus && (finishUpdateToken || !userInfo?.tokenRefresh)) {
      const timeoutId = setTimeout(() => {
        getListGavel();
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [page, type, focus, finishUpdateToken]);

  useEffect(() => {
    if (focus && (finishUpdateToken || !userInfo?.tokenRefresh)) {
      const timeoutId = setTimeout(() => {
        getListBanner();
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [focus, finishUpdateToken]);

  function onEndReached() {
    if (page < qtdPages) {
      setPage(page + 1);
    }
  }

  const renderItemGavel = ({item}: any) => {
    return (
      <S.Item>
        <S.RowItem>
          <S.ImageToken
            source={{
              uri: item.token_logo,
            }}
            resizeMode="contain"
          />
          <S.Column>
            <TextDefault
              fontSize={14}
              color={theme.colors(appTheme).white}
              text={item.token_name || ''}
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
            <TextDefault
              fontSize={10}
              color={theme.colors(appTheme).white}
              text={`Qtd. ${item.qtd || 0} | ${item.user_name}`}
              marginTop={5}
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
          </S.Column>
        </S.RowItem>
        <S.Column style={{alignItems: 'flex-end'}}>
          <TextDefault
            fontSize={10}
            color={theme.colors(appTheme).white}
            text={`R$ ${toPrice(
              item.type === 'direta' ? item.value_unity : item.min_value,
              2,
            )}`}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
          <TextDefault
            fontSize={10}
            color={theme.colors(appTheme).green[900]}
            text={`${item.appreciation}%`}
            marginTop={5}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
        </S.Column>
      </S.Item>
    );
  };

  const renderItem = ({item}: any) => (
    <S.CardCarrousel>
      <S.BannerImage
        source={{uri: listBanners[item]}}
        resizeMode="contain"
        style={{backgroundColor: theme.colors(appTheme).black[700]}}
      />
    </S.CardCarrousel>
  );

  return (
    <>
      <StatusBarContainer />
      <S.Container appTheme={appTheme}>
        <S.ContainerArea appTheme={appTheme}>
          <S.Header>
            <S.CircleImage>
              <S.Image source={Logo} resizeMode="contain" />
            </S.CircleImage>
            <TextDefault
              fontSize={20}
              color={theme.colors(appTheme).white}
              marginTop={20}
              marginBottom={20}
              text="DSS Exchange"
              fontFamily={theme.fonts.family.opensans.semi_bold}
              textAlign="center"
            />
          </S.Header>
          {!listBanners?.length ? null : (
            <View style={{height: 160}}>
              <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ paddingRight: 10 }}>
                {[...new Array(listBanners.length).keys()].map((item) => renderItem({item}))}
              </ScrollView>
            </View>
          )}
          <S.Welcome>
            <TextDefault
              fontSize={20}
              color={theme.colors(appTheme).white}
              text={`Seja bem vindo, ${userInfo?.user?.name || 'Visitante'}`}
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
            {!userInfo?.user?.id ? null : (
              <TextDefault
                fontSize={20}
                color={theme.colors(appTheme).white}
                text={`Você tem R$ ${toPrice(userInfo?.user?.wallet || 0, 2)}`}
                fontFamily={theme.fonts.family.opensans.semi_bold}
              />
            )}
            <Input
              title=""
              errors={errors}
              placeholder="Pesquisar lote em oferta"
              control={control}
              name="searchTxt"
              width="100%"
              marginTop={10}
              Icon={
                <S.IconImageMaterialIcons
                  name="search"
                  size={20}
                  color={theme.colors(appTheme).white}
                />
              }
              hideBorder
            />
            <S.Row style={{marginTop: 10}}>
              <Button
                title="Maiores Altas"
                onPress={() =>
                  setType(type === 'maiores_altas' ? '' : 'maiores_altas')
                }
                fontFamily={theme.fonts.family.opensans.bold}
                fontColor={theme.colors(appTheme).backgroundColor}
                backgroundColor={
                  type === 'maiores_altas'
                    ? theme.colors(appTheme).main[700]
                    : theme.colors(appTheme).white
                }
                width="32%"
                fontSize={9}
                borderRadius={30}
                height={40}
                Icon={
                  <S.IconImageMaterialIcons
                    name="trending-up"
                    size={20}
                    color={theme.colors(appTheme).backgroundColor}
                  />
                }
              />
              <Button
                title="Venda Direta"
                onPress={() =>
                  setType(type === 'venda_direta' ? '' : 'venda_direta')
                }
                fontFamily={theme.fonts.family.opensans.bold}
                fontColor={theme.colors(appTheme).backgroundColor}
                backgroundColor={
                  type === 'venda_direta'
                    ? theme.colors(appTheme).main[700]
                    : theme.colors(appTheme).white
                }
                width="32%"
                fontSize={9}
                borderRadius={30}
                height={40}
                Icon={
                  <S.IconImageMaterialIcons
                    name="gavel"
                    size={16}
                    color={theme.colors(appTheme).backgroundColor}
                  />
                }
              />
              <Button
                title="Maior Lance"
                onPress={() =>
                  setType(type === 'maior_lance' ? '' : 'maior_lance')
                }
                fontFamily={theme.fonts.family.opensans.bold}
                fontColor={theme.colors(appTheme).backgroundColor}
                backgroundColor={
                  type === 'maior_lance'
                    ? theme.colors(appTheme).main[700]
                    : theme.colors(appTheme).white
                }
                width="32%"
                fontSize={9}
                borderRadius={30}
                height={40}
                Icon={
                  <S.IconImageMaterialCommunityIcons
                    name="clock-fast"
                    size={20}
                    color={theme.colors(appTheme).backgroundColor}
                  />
                }
              />
            </S.Row>
          </S.Welcome>
          {isLoading ? (
            <ActivityIndicator
              size="large"
              color={theme.colors(appTheme).white}
              style={{marginTop: 40}}
            />
          ) : (
            <FlatList
              data={listGavel}
              renderItem={renderItemGavel}
              keyExtractor={item => String(item.id)}
              style={{width: '100%'}}
              contentContainerStyle={{
                paddingBottom: 60,
                paddingTop: 20,
                alignItems: 'center',
              }}
              indicatorStyle={appTheme === 'dark' ? 'white' : 'black'}
              onEndReached={onEndReached}
              onEndReachedThreshold={0.3}
            />
          )}
        </S.ContainerArea>
      </S.Container>
    </>
  );
}
